import { DELETE_IMAGE_REQUEST, DELETE_IMAGE_SUCCESS, DELETE_IMAGE_ERROR } from "../actions/deleteImage"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const deleteImage = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_IMAGE_REQUEST:
            return {
                ...state,
                loading: true
            }

        case DELETE_IMAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case DELETE_IMAGE_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }

        default:
            return state;
    }
}

export default deleteImage